import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const putProjectForm = (
    backend: string,
    token: string,
    id: number,
    EmployeeID: number,
    Name: string,
    Description: string,
    ChangedByID: number,
    components?,
    SignatureBy?,
) => {
    return fetch(
        `${getApiUrl(backend)}project_forms/${id}`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                EmployeeID,
                SignatureBy,
                Name,
                Description,
                ChangedByID,
                CreatedByID: ChangedByID,
                components
            })
        }
    );
};

export default putProjectForm;
